import PCustomerDetail from 'components/Tvendo/Article/Operations/ProviderCustomer/Detail/PCustomerDetail';
import React from 'react';

export default function () {
  return <PCustomerDetail />;
}
